var React = require('react');

function IconRefund (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z","fill":"#F9B845"}));
}

IconRefund.defaultProps = {"viewBox":"0 0 32 32","fill":"none"};

module.exports = IconRefund;

IconRefund.default = IconRefund;
